import { WASHMEN_CUSTOMER_API } from 'api/config';
import type { Addresses } from 'api/types/addresses.types';
import type { Customer } from 'api/types/user.types';
import type { AddressForm } from 'schemas/address-schema';

export async function addCustomerAddressAPI(address: AddressForm) {
  return (await WASHMEN_CUSTOMER_API.post<{ address: Addresses.Address }>('/addresses', address)).data;
}

export async function fetchCustomerAddressesAPI(isLastUsedAddressOnly = false) {
  return (await WASHMEN_CUSTOMER_API.get<{ addresses: Addresses.Address[] }>(`/addresses?isLastUsedAddressOnly=${isLastUsedAddressOnly}`)).data;
}

export async function deleteCustomerAddressAPI(id: string) {
  return (await WASHMEN_CUSTOMER_API.delete<{ updatedUser: Customer.Customer }>(`/addresses/${id}`)).data;
}

export async function editCustomerAddressAPI(address: AddressForm, addressId: string) {
  return (await WASHMEN_CUSTOMER_API.put<{ address: Addresses.Address }>(`/addresses/${addressId}`, address)).data.address;
}

export async function validateAddressAPI(position: { lat: number | string; lng: number | string }) {
  return (
    await WASHMEN_CUSTOMER_API.get<{ geofence: Addresses.Geofence }>(`/addresses/check`, {
      params: {
        country: 'uae',
        lat: position.lat,
        lng: position.lng,
      },
    })
  ).data;
}
